const tickerItems = [
  "「塌房预警」某顶流直播翻车全记录已上线",
  "网友实锤：三线综艺常驻嘉宾私聊截图流出",
  "深扒更新：演员与经纪人合约纠纷内幕再曝新料",
  "热搜第一的道歉声明，被挖出三年前旧账",
  "「综艺人设」崩塌复盘：从金句担当到全网追问",
  "品牌连夜解约事件完整时间轴已整理",
  "新晋偶像被指抄袭舞蹈动作，评论区吵翻",
  "狗仔实拍：歌手深夜聚餐疑似新恋情",
];

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="border-b border-foreground-200/60 bg-background-950 text-background-50">
      <div className="relative mx-auto flex max-w-[1400px] items-center overflow-hidden px-4">
        <span className="z-10 -my-px mr-3 inline-flex shrink-0 items-center gap-1.5 bg-primary-500 px-3 py-1.5 text-xs font-bold text-foreground-50">
          <i className="ri-broadcast-fill" /> 实况
        </span>
        <div className="relative flex h-9 flex-1 items-center overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
            {doubled.map((t, i) => (
              <a href="#feed" key={i} className="flex items-center gap-2 text-xs text-background-100/90 transition-colors hover:text-background-50">
                <i className="ri-record-circle-fill text-[8px] text-primary-400" />
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}